const ListItemMixin = {
  props: ['side'],
  created () {
  },
  data () {
    return {
      errors: {
      },
      counterDoneSmall: 0,
      counterDoneBig: 0,
      counterToBeDoneSmall: 0,
      counterToBeDoneBig: 0,
      infoCounterToBeDoneSmall: '',
      infoCounterToBeDoneBig: '',
      notAssignableMedia: ['PlayListDesktop', 'PlayListLibrary', 'PlayListLibraryFolder', 'PlayListLibraryRoot'],
      assignPossibilitiesDialogVisible: false,
      selectedGroup: {
        name: ''
      }
    }
  },
  methods: {
    changeSelectedGroup (value) {
      this.selectedGroup = JSON.parse(JSON.stringify(this.$store.state.Device.device_desktop_groups.find(ddg => ddg.id === value)))
    },
    /**
     *  M E D I A   L I N K E R
     */
    showLinkButton () {
      if (this.checkCanAssignPrivilegesToRoles ||
          this.checkCanMakeMediaFromFilesAndCreatePlaylist ||
          this.checkCanMakeMediaFromFilesAndAssignToPlaylist ||
          this.checkCanAssignMediaToPlaylists ||
          this.checkCanAssignMediaToDesktops ||
          this.checkCanAssignDesktopsToGroup ||
          this.checkCanAssignTagsToMedia ||
          this.checkCanMakePlaylistWithMedia) {
        return true
      } else {
        return false
      }
    },
    showAssignPossibilitiesDialog () {
      this.assignPossibilitiesDialogVisible = true
    },
    closeAssignPossibilitiesDialog () {
      this.assignPossibilitiesDialogVisible = false
    },
    async assignTagsToMedia () {
      let media = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_left))
      this.counterToBeDoneBig = media.length
      this.infoCounterToBeDoneSmall = this.$t('Tags done')
      this.infoCounterToBeDoneBig = this.$t('Media done')
      for (let index = 0; index < media.length; index++) {
        this.counterDoneSmall = 0
        this.counterToBeDoneSmall = this.$store.state.Clipboard.copied_media_tags.length
        for (let index2 = 0; index2 < this.$store.state.Clipboard.copied_media_tags.length; index2++) {
          this.counterDoneSmall++
          await this.$store.dispatch('Medium/addMediumTagToMedium', [this.$store.state.Clipboard.copied_media_tags[index2].id, media[index].id])
        }
        await this.$store.dispatch('Medium/getMedium', {
          data: media[index].id,
          options: { populate: true }
        })
        this.counterDoneBig++
      }
      this.counterDoneBig = 0
      this.counterToBeDoneBig = 0
      await this.$store.dispatch('Medium/setMediaTags')
      this.assignPossibilitiesDialogVisible = false
    },
    async createPlaylistWithMedia () {
      this.assignPossibilitiesDialogVisible = false
      let childrenMedia = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_left))
      let playListCreatedId = await this.$store.dispatch('Medium/createPlaylist', this.playlist.name)
      this.counterToBeDoneSmall = childrenMedia.length
      this.infoCounterToBeDoneSmall = this.$t('Media done')
      for (let index = 0; index < childrenMedia.length; index++) {
        await this.$store.dispatch('Medium/assignMediumToPlaylist', [playListCreatedId, childrenMedia[index].id])
        this.counterDoneSmall++
      }
      this.counterDoneSmall = 0
      this.counterToBeDoneSmall = 0
    },
    async assignMediaToPlaylists () {
      this.assignPossibilitiesDialogVisible = false
      let childrenMedia = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_left))
      let playlistsToAssingTo = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_right))
      this.counterToBeDoneBig = playlistsToAssingTo.length
      this.infoCounterToBeDoneBig = this.$t('PlayLists done')
      for (let index = 0; index < playlistsToAssingTo.length; index++) {
        await this.assignMediaToPlaylist(playlistsToAssingTo[index], childrenMedia)
        this.counterDoneBig++
      }
      this.counterDoneBig = 0
      this.counterToBeDoneBig = 0
      this.$emit('linkerJobDone')
    },
    async assignMediaToPlaylist (optionalParentMedium, optionalchildrenMedia) {
      this.assignPossibilitiesDialogVisible = false
      let parentMedium
      let childrenMedia
      if (!optionalParentMedium) {
        parentMedium = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_right[0]))
      } else {
        parentMedium = optionalParentMedium
      }
      if (!optionalParentMedium) {
        childrenMedia = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_left))
      } else {
        childrenMedia = optionalchildrenMedia
      }
      this.counterToBeDoneSmall = childrenMedia.length
      this.infoCounterToBeDoneSmall = this.$t('Media done')
      for (const child of childrenMedia.filter(m => !m.type.startsWith('PlayListLibrary'))) {
        await this.$store.dispatch('Medium/assignMediumToPlaylist', [parentMedium.id, child.id])
        this.counterDoneSmall++
      }
      await this.$store.dispatch('Medium/getMedium', {
        data: parentMedium.id,
        options: { populate: true }
      })
      this.counterToBeDoneSmall = 0
      this.counterDoneSmall = 0
      this.$store.dispatch('Medium/resetDraggedOverPlayitem')
      this.$store.dispatch('User/sendBroadcastMessage', { Rooms: 'Playlist_changed', Data: { playlistId: parentMedium.id, userId: this.$store.state.User.user.id } })
    },
    async assignDesktopsToGroup () {
      this.assignPossibilitiesDialogVisible = false
      let desktopsToAssign = JSON.parse(JSON.stringify(this.$store.state.Device.desktops_selected_right))
      this.counterToBeDoneBig = desktopsToAssign.length
      this.infoCounterToBeDoneBig = this.$t('Desktops assigned to group')
      for (let index = 0; index < desktopsToAssign.length; index++) {
        await this.$store.dispatch('Device/assignDesktopToGroup', [desktopsToAssign[index].id, this.selectedGroup.id])
        this.counterDoneBig++
      }
      this.counterDoneBig = 0
      this.counterToBeDoneBig = 0
      this.selectedGroup = { name: '' }
      this.$store.dispatch('Device/clearDesktopsSelectedRight')
    },
    /**
     *  R O L E S / P R I V I L E G E S   L I N K E R
     */
    async assignPrivilegesToRoles () {
      if (!this.checkCanAssignPrivilegesToRoles()) {
        throw Error('Can\'n call this method without proper selection.')
      }

      const privilegeIds = this.$store.state.Privilege.privileges_selected_left.map(item => item.id)
      const roleIds = this.$store.state.Role.roles_selected_right.map(item => item.id)

      this.counterToBeDoneSmall = roleIds.length
      this.counterDoneSmall = 0

      for (let index = 0; index < roleIds.length; index++) {
        await this.$store.dispatch('Role/assignPrivilegesToRoles', { roleId: roleIds[index], privilegesIds: privilegeIds })
        this.counterDoneSmall++
      }

      this.counterToBeDoneSmall = 0
      this.counterDoneSmall = 0
    }
  },

  computed: {
    checkCanAssignTagsToMedia () {
      if (this.$store.state.Clipboard.copied_media_tags.length !== 0 && this.$store.state.Medium.media_selected_left.length !== 0) {
        return true
      }
    },
    checkCanAssignPrivilegesToRoles () {
      if (this.$store.state.Privilege.privileges_selected_left.length !== 0 && this.$store.state.Role.roles_selected_right.length !== 0) {
        return true
      }
    },
    checkCanAssignMediaToPlaylists () {
      if (this.counterDoneSmall !== 0 || this.counterDoneBig !== 0) return false
      let mediaSelectedLeft = this.$store.state.Medium.media_selected_left
      let mediaSelectedRight = this.$store.state.Medium.media_selected_right
      if (mediaSelectedRight.length < 1) return false
      if (mediaSelectedLeft.length === 0) return false
      for (let index = 0; index < mediaSelectedLeft.length; index++) {
        if (this.notAssignableMedia.indexOf(mediaSelectedLeft[index].type) !== -1) return false
      }
      for (let index = 0; index < mediaSelectedRight.length; index++) {
        if (['PlayListDesktop', 'PlayList', 'PlayListLayout'].indexOf(mediaSelectedRight[index].type) === -1) return false
      }
      return true
    },
    checkCanAssignMediaToDesktops () {
      if (this.counterDoneSmall !== 0 || this.counterDoneBig !== 0) return false
      if (this.$store.state.Medium.media_selected_left.length === 0) {
        return false
      }
      if (this.$store.state.Device.desktops_selected_right.length === 0) {
        return false
      }
      for (let index = 0; index < this.$store.state.Medium.media_selected_left.length; index++) {
        const mediumSelected = this.$store.state.Medium.media_selected_left[index]
        if (this.notAssignableMedia.indexOf(mediumSelected.type) !== -1) return false
      }
      return true
    },
    checkCanAssignDesktopsToGroup () {
      if (this.counterDoneSmall !== 0 || this.counterDoneBig !== 0) return false
      if (this.$store.state.Device.desktops_selected_right.length === 0) {
        return false
      }
      return true
    },
    checkCanMakePlaylistWithMedia () {
      if (this.counterDoneSmall !== 0 || this.counterDoneBig !== 0) return false
      if (this.$store.state.Medium.media_selected_left.length === 0) return false
      for (let index = 0; index < this.$store.state.Medium.media_selected_left.length; index++) {
        const mediumSelected = this.$store.state.Medium.media_selected_left[index]
        if (this.notAssignableMedia.indexOf(mediumSelected.type) !== -1) return false
      }
      return true
    },
    percentDoneSmall () {
      if ((this.counterDoneSmall === 0 && this.counterToBeDoneSmall === 0) ||
        (this.counterDoneSmall > this.counterToBeDoneSmall) ||
        (this.counterDoneSmall !== 0 && this.counterToBeDoneSmall === 0)
      ) {
        return 100
      }

      return Math.round(this.counterDoneSmall / this.counterToBeDoneSmall * 100)
    },
    percentDoneBig () {
      if ((this.counterDoneBig === 0 && this.counterToBeDoneBig === 0) ||
        (this.counterDoneBig > this.counterToBeDoneBig) ||
        (this.counterDoneBig !== 0 && this.counterToBeDoneBig === 0)
      ) {
        return 100
      }

      return Math.round(this.counterDoneBig / this.counterToBeDoneBig * 100)
    },
    counterToBeDoneSmallVisible () {
      return this.percentDoneSmall !== 100
    },
    counterToBeDoneBigVisible () {
      return this.percentDoneBig !== 100
    },
    progressDialogVisible () {
      return this.counterToBeDoneSmallVisible || this.counterToBeDoneBigVisible
    }
  }
}
export default ListItemMixin



// WEBPACK FOOTER //
// ./src/components/Linker/assign2.mixin.js